<app-ref-list [page]="query.page()"
              [hide]="store.account.ignoreNotifications()"
              [showPrev]="false"
              [showPageLast]="false" />
